import styled from 'styled-components';

export const StyledScrollShadow = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.colors.background} 0%,
    ${({ theme }) => `${theme.colors.background}CC`} 20%,
    ${({ theme }) => `${theme.colors.background}99`} 50%,
    ${({ theme }) => `${theme.colors.background}33`} 80%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 10;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  /* Use theme colors for border and glow */
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 5px 1px ${({ theme }) => `${theme.colors.primary}33`};
  }

  /* Keep the animation but make it more subtle */
  animation: shadowPulse 2.5s ease-in-out infinite;

  @keyframes shadowPulse {
    0%,
    100% {
      opacity: 1;
      transform: translateY(0);
    }
    50% {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
`;

export const ScrollShadowIconWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 5px;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: iconBounce 2s ease-in-out infinite;

  @keyframes iconBounce {
    0%,
    100% {
      transform: translateX(-50%) translateY(0);
    }
    50% {
      transform: translateX(-50%) translateY(2px);
    }
  }
`;
